<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="majesticons:pound-circle-line">
<g id="Group">
<path id="Vector" d="M24 44C35.046 44 44 35.046 44 24C44 12.954 35.046 4 24 4C12.954 4 4 12.954 4 24C4 35.046 12.954 44 24 44Z" stroke="#1B0777" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M30 18C30 14.8 27.334 14 26 14C24.666 14 22 14.8 22 18V24M22 24V28C22 29.334 21.2 32 18 32H30M22 24H26M22 24H18" stroke="#1B0777" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
